import React from 'react';
import { useTranslation } from 'react-i18next';
import { commonStyles } from '../../../styles/commonStyles';

// Rental-unit counts for the Eigendom & Verhuur coverage (RP code 9520). Shown only
// when that coverage is selected; the three counts must total 1 or 2 units.
interface RentalUnitsFieldsProps {
  data: any;
  setData: React.Dispatch<React.SetStateAction<any>>;
}

const RENTAL_FIELDS = [
  { id: 'rp_vwe', field: 'RP_VWE', labelKey: 'residentialUnits', fallback: 1 },
  { id: 'rp_vbe', field: 'RP_VBE', labelKey: 'businessUnits', fallback: 0 },
  { id: 'rp_vgavrh', field: 'RP_VGAVRH', labelKey: 'garages', fallback: 0 },
] as const;

export const RentalUnitsFields: React.FC<RentalUnitsFieldsProps> = ({ data, setData }) => {
  const { t } = useTranslation();
  const rpE = data?.Contractdocument?.PP?._rpEigendom || {};
  const values = Object.fromEntries(RENTAL_FIELDS.map((f) => [f.field, rpE[f.field] ?? f.fallback]));
  const totalUnits = RENTAL_FIELDS.reduce((sum, f) => sum + values[f.field], 0);
  const isInvalid = totalUnits < 1 || totalUnits > 2;

  const updateField = (field: string, val: number) => {
    setData((prev: any) => ({
      ...prev,
      Contractdocument: {
        ...prev.Contractdocument,
        PP: {
          ...prev.Contractdocument?.PP,
          _rpEigendom: { ...prev.Contractdocument?.PP?._rpEigendom, [field]: val },
        },
      },
    }));
  };

  return (
    <>
      <div style={commonStyles.coverageDivider} />
      <div style={{ padding: '4px 0' }}>
        <label style={commonStyles.fieldGroupLabel}>
          {t('screens.rechtsbijstand.rentalUnits.title')}
        </label>
        <div style={commonStyles.fieldRow}>
          {RENTAL_FIELDS.map(({ id, field, labelKey }) => (
            <div key={id} style={commonStyles.fieldColumn}>
              <label style={commonStyles.fieldLabel} htmlFor={id}>
                {t(`screens.rechtsbijstand.rentalUnits.${labelKey}`)}
              </label>
              <input
                id={id}
                type="number"
                min="0"
                max="2"
                value={values[field]}
                onChange={(e) => updateField(field, parseInt(e.target.value, 10) || 0)}
                style={{ ...commonStyles.fieldInput, ...(isInvalid ? commonStyles.fieldInputError : {}) }}
              />
            </div>
          ))}
        </div>
        {isInvalid && (
          <p style={commonStyles.errorMessage}>
            {totalUnits < 1
              ? t('screens.rechtsbijstand.rentalUnits.minError')
              : t('screens.rechtsbijstand.rentalUnits.maxError')}
          </p>
        )}
      </div>
    </>
  );
};

export default RentalUnitsFields;
